import script from "./ListaModelos.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListaModelos.vue?vue&type=script&lang=ts&setup=true"

import "./ListaModelos.vue?vue&type=style&index=0&id=70e47360&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e47360"]])

export default __exports__